import React from 'react';
import Login from "./Login";
import {useDispatch, useSelector} from "react-redux";
import Signup from "./Signup";
import { setLogin, setSignUp } from "../../../../Features/Misc/loginSlice";

import { Animate } from "react-simple-animate";

export default function SignUpRight() {

    //redux methods here
    const dispatch = useDispatch()

    //redux state here
    const { actionType } = useSelector((state) => state.login)


    return (
        <div className="right-inner row-start-2 row-end-12 col-start-1 col-end-13 flex flex-col justify-between text-white grid grid-cols-12 grid-rows-12 ">
            <div className="stepTwo-right-table col-start-3 col-end-11 2xl:col-start-4 2xl:col-end-10 row-start-1 row-end-13 flex text-2xl text-white/50 flex-col gap-4 ">
                <div className="stepTwo-right-table-actionSelector-container flex flex-row text-3xl gap-12  h-16">

                    <Animate play start={{ opacity: 0}} end={{ opacity: 1 }} duration={1.5} >
                        <div
                            onClick={() => dispatch(setSignUp())}
                            className={actionType === "Sign Up" ? `selector-option1 text-white  cursor-pointer` :`selector-option1 cursor-pointer` }
                        >
                            Sign Up
                        </div>
                    </Animate>

                    <Animate play start={{ opacity: 0}} end={{ opacity: 1 }} duration={0.7} >
                        <div
                            onClick={() => dispatch(setLogin())}
                            className={actionType === "Log In" ? `selector-option2 text-white  cursor-pointer` :`selector-option2 cursor-pointer` }
                        >
                            Log In
                        </div>
                    </Animate>



                </div>
                { actionType === "Log In" && <Login />}
                { actionType === "Sign Up" && <Signup />}
            </div>

        </div>
    );
}



